export var getStoreId = function (instance) {
    var storeId = extractInstanceId(instance);
    if (!storeId) {
        throw new Error('StoreId is missing');
    }
    return storeId;
};
var parseJwt = function (token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    }
    catch (e) {
        return null;
    }
};
var extractInstanceId = function (instance) {
    var jwt = parseJwt(instance);
    if (jwt) {
        return jwt.instanceId;
    }
    return null;
};
//# sourceMappingURL=getStoreId.js.map